// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import addLeadingZero from './addLeadingZero'

// returns HH:MM:SS for the amount of time that has passed since
const getDuration = (startTime, endTime) => {
  // if we have no start time, then there's nothing to count.
  if (startTime === null) {
    return '-'
  }
  // if endTime is null, then we're not done yet. Base
  // the duration off of Date.now()
  let diff = ((endTime || Date.now()) - startTime) / 1000

  const h = Math.floor(diff / 3600)
  const hh = addLeadingZero(h)
  diff -= h * 3600

  const m = Math.floor(diff / 60) % 60
  const mm = addLeadingZero(m)
  diff -= m * 60

  const s = Math.floor(diff % 60)
  const ss = addLeadingZero(s)

  return `${hh}:${mm}:${ss}`
}

export default getDuration
